
import { Navigation } from "./Navigation";

export const StickyNavigation = () => {
  return <Navigation />;
};
